/**
 * Constants for the DUA Playground tool.
 */

/**
 * Default JSON Schema demonstrating each supported field type.
 * Includes examples of context-based visibility (showInContexts)
 * and context overrides (contextOverrides).
 */
export const DEFAULT_DUA_SCHEMA = JSON.stringify({
  title: 'Example Form',
  type: 'object',
  properties: {
    text_field: {
      title: 'Text Field',
      type: 'string',
    },
    textarea_field: {
      title: 'Textarea Field',
      type: 'string',
      displayAs: 'textarea',
    },
    boolean_field: {
      title: 'Boolean Field',
      type: 'boolean',
    },
    select_field: {
      title: 'Select Field',
      type: 'string',
      enum: ['Option A', 'Option B', 'Option C'],
    },
    number_field: {
      title: 'Number Field',
      type: 'number',
    },
    context_visible_field: {
      title: 'Reviews Only Field',
      description: 'This field only appears in reviews context',
      type: 'string',
      showInContexts: ['reviews'],
    },
    context_override_field: {
      title: 'Default Title',
      description: 'Default description',
      type: 'string',
      showInContexts: ['default', 'reviews'],
      contextOverrides: {
        reviews: {
          title: 'Overridden Title for Reviews',
          description: 'Overridden description for reviews context',
        },
      },
    },
  },
  required: ['text_field', 'boolean_field'],
  order: ['context_override_field', '*'],
});

/** Default "before" form data for diff view */
export const DEFAULT_BEFORE_DATA = JSON.stringify({
  text_field: 'sample field',
  boolean_field: true,
  select_field: 'Option C',
  number_field: 12312,
  context_override_field: '123',
});

/** Default "after" form data for diff view */
export const DEFAULT_AFTER_DATA = JSON.stringify({
  text_field: 'changed sample field',
  textarea_field: 'new data',
  boolean_field: true,
  select_field: 'Option B',
  number_field: 23423,
  context_override_field: '123',
});
